import { getElem, pause } from "../utils";
import { lionRoar } from "../utils/assets";

let IMAGECOUNT = 180;
class HTML_Desktop {
    private html = {
        desktop: getElem("desktop"),
        footer: getElem("footer"),
        footerLink: getElem("nestleLink"),
        scenery: getElem("desktop-scenery"),
        lion: getElem("desktop-lion"),
    };

    constructor() {
        let roarImages = lionRoar;
        roarImages.then((images) => {
            IMAGECOUNT = images.length;
            for(let i = 0; i < IMAGECOUNT; i++) {
                const img = document.createElement("img");
                img.setAttribute(
                    'src', 
                    images[i],
                )
                img.setAttribute(
                    'id',
                    `desktop-lion${i.toString().padStart(3, '0')}`
                )
                this.html.lion.appendChild(img);
            }
        })

    }
    
    public async show() {
        this.html.footer.style.bottom = "0px";
        this.html.footer.style.height = "10%";
        this.html.footerLink.style.fontSize = "1.7vh";
        this.html.desktop.style.display = "flex";
        await pause(200);
        this.html.desktop.style.opacity = "1";
        this.html.scenery.style.bottom = "1vh";
        this.startLionRoar();
    }

    private async startLionRoar() {
        for(let i = 0; i < IMAGECOUNT; i++) {
            let myLion = getElem(`desktop-lion${i.toString().padStart(3, '0')}`);
            myLion.style.display = "block";
            if(i > 0) {
                let lastLion = getElem(`desktop-lion${(i - 1).toString().padStart(3, '0')}`);
                lastLion.style.display = "none";
            }
            await pause(30);
        }
        let lastLion = getElem(`desktop-lion${(IMAGECOUNT - 1).toString().padStart(3, '0')}`);
        lastLion.style.display = "none";
        this.startLionRoar();
    }
    
}

export default HTML_Desktop;